import React from 'react';

function Checkboxes({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
      {...otherProps}
    >
      <rect x="7.65" y="1.65" width="8.7" height="8.7" rx="1.35" />
      <path d="M16 3L12 7L10.5 5.5" />
      <rect x="7.65" y="13.65" width="8.7" height="8.7" rx="1.35" />
    </svg>
  );
}

export default Checkboxes;
